import React from "react";
import Color from "color";
import { useClasses } from "../../";
import classNames from "classnames";
const styles = (theme) => ({
    link: {
        backgroundColor: "#fff",
        border: "none",
        outline: "none",
        padding: 0,
        margin: 0,
        color: theme.palette.get("primary"),
        cursor: "pointer",
        "&:hover": {
            color: theme.palette.get("tertiary"),
        },
    },
    button: {
        height: "32px",
        border: "none",
        outline: "none",
        background: theme.palette.get("default"),
        fontFamily: '"Noto Sans", sans-serif',
        fontSize: "1rem",
        cursor: "pointer",
        borderRadius: "2px",
        padding: "2px 8px",
        marginTop: (props) => (props.alignFloating ? "18px" : "0px"),
        width: (props) => props.width || "100%",
        "&:hover": {
            background: "#bfbfbf",
        },
    },
    "button-primary": {
        background: theme.palette.get("primary"),
        color: "#fff",
        "&:hover": {
            background: Color(theme.palette.get("primary")).darken(0.3).hex(),
        },
    },
    "button-warning": {
        background: theme.palette.get("warning"),
        color: "#fff",
        "&:hover": {
            background: Color(theme.palette.get("warning")).darken(0.3).hex(),
        },
    },
    "button-success": {
        background: theme.palette.get("success"),
        color: "#fff",
        "&:hover": {
            background: Color(theme.palette.get("success")).darken(0.3).hex(),
        },
    },
    "button-danger": {
        background: theme.palette.get("danger"),
        color: "#fff",
        "&:hover": {
            background: Color(theme.palette.get("danger")).darken(0.3).hex(),
        },
    },
    "button-tertiary": {
        background: theme.palette.get("tertiary"),
        color: "#fff",
        "&:hover": {
            background: Color(theme.palette.get("tertiary")).darken(0.3).hex(),
        },
    },
    "button-secondary": {
        background: theme.palette.get("secondary"),
        color: "#fff",
        "&:hover": {
            background: Color(theme.palette.get("secondary")).darken(0.3).hex(),
        },
    },
    "button-disabled": {
        background: "#ebebeb",
        color: "#fff",
        cursor: "not-allowed",
        "&:hover": {
            background: "#ebebeb",
        },
    },
});
function Button(props) {
    const { children, primary, secondary, tertiary, success, warning, danger, link, type, onClick = () => { }, style = {}, } = props;
    const variant = (primary && "primary") ||
        (secondary && "secondary") ||
        (tertiary && "tertiary") ||
        (success && "success") ||
        (warning && "warning") ||
        (danger && "danger") ||
        "default";
    const classes = useClasses(styles, props);
    return (React.createElement("button", { disabled: props.disabled, className: classNames([
            !link && classes.button,
            link && classes.link,
            !props.disabled
                ? classes[`button-${variant}`]
                : !link && classes["button-disabled"],
        ]), type: props.submit ? "submit" : type, onClick: (e) => {
            if (!props.submit)
                e.preventDefault();
            if (!props.disabled)
                onClick();
        }, style: style }, children));
}
export default Button;
